export default __webpack_public_path__ + "static/2-f455e7836a7961b4e0dc9c33365213aa.png";